import { useRef } from 'react'

import { useDebounceFunc } from '../../../../../hooks'
import { GRETA_AI_CHAT_SETTLED_GENERATION_GRACE_MS } from '../../../GretaAIChat.constants'
import {
  getGretaAIChatChatsWithoutStaleRunning,
  getHasGretaAIChatStaleRunning,
  getIsGretaAIChatSettledRecently,
} from '../useGretaAIChatChatListLoader.utils'

// Within the grace after a settle, a read of that chat can still say `running` (read replica).
export function useGretaAIChatSettledGenerations({ setChats, onRecheck }) {
  const settledAtByIdRef = useRef(new Map())

  const { debouncedHandler: scheduleStaleRunningRecheck } = useDebounceFunc(
    onRecheck,
    GRETA_AI_CHAT_SETTLED_GENERATION_GRACE_MS
  )

  function hideStaleRunningChats(loadedChats, requestedAt) {
    if (
      getHasGretaAIChatStaleRunning({
        chats: loadedChats,
        requestedAt,
        settledAtById: settledAtByIdRef.current,
      })
    ) {
      scheduleStaleRunningRecheck()
    }

    return getGretaAIChatChatsWithoutStaleRunning({
      chats: loadedChats,
      requestedAt,
      settledAtById: settledAtByIdRef.current,
    })
  }

  function markChatGenerationSettled(id) {
    const settledAt = performance.now()

    settledAtByIdRef.current.set(id, settledAt)
    setChats(current =>
      getGretaAIChatChatsWithoutStaleRunning({
        chats: current,
        requestedAt: settledAt,
        settledAtById: settledAtByIdRef.current,
      })
    )
  }

  function getIsChatGenerationSettledRecently(id) {
    return getIsGretaAIChatSettledRecently({
      id,
      requestedAt: performance.now(),
      settledAtById: settledAtByIdRef.current,
    })
  }

  return {
    getIsChatGenerationSettledRecently,
    hideStaleRunningChats,
    markChatGenerationSettled,
  }
}
